import React from 'react'
import styles from './Warning.module.scss'
import classNames from 'classnames'

const Warning = (props) => {

    return <div className={classNames({
        [styles['warning']]: true,
        [styles['warning-red']]: props.color === 'red',
        [styles['warning-yellow']]: props.color === 'yellow'
    })}>{props.children}</div>
}

export default Warning